// Lib
import { useEffect } from 'react';
import Handsontable from 'handsontable/base';
import usePrevious from '../../../../utils/react/usePrevious';

interface UseTableColumnResizeEffectsProps {
    gridSize: number;
    hotTableInstanceRef: React.MutableRefObject<Handsontable.Core | null>;
}

/**
 * Custom hook for managing table column resize side effects
 *
 * @param props - Hook configuration
 */
export const useTableColumnResizeEffects = (props: UseTableColumnResizeEffectsProps): void => {
    const { gridSize, hotTableInstanceRef } = props;

    const prevGridSize = usePrevious(gridSize);

    /**
     * Update row height when grid size changes
     */
    useEffect(() => {
        const manualRowResizePlugin = hotTableInstanceRef.current?.getPlugin<'manualRowResize'>('manualRowResize');

        if (!hotTableInstanceRef.current || !manualRowResizePlugin || !prevGridSize) return;

        const nRows = hotTableInstanceRef.current.countRows();

        for (let row = 0; row < nRows; row++) {
            const offset = row === nRows - 1 ? 1 : 0;

            const currentHeightPx = hotTableInstanceRef.current.getRowHeight(row) + offset;
            const currentHeightGU = currentHeightPx / prevGridSize;

            const nextHeightPx = currentHeightGU * gridSize - offset;

            manualRowResizePlugin.setManualSize(row, nextHeightPx);
        }
    }, [gridSize]);
};

export default useTableColumnResizeEffects;
